import React, { useEffect, useRef, useState } from 'react'
import "./PrivacyPolicy.scss"

const PrivacyPolicy = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME

  useEffect(() => {
    document.title = companyName + ' - Privacy Policy'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `This privacy policy will explain how our organisation uses the personal data we collect from you when you use our website.`)
    }
  }, [])
  return (
    <section className="privacy-policy">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>
          This privacy policy will explain how our organisation uses the personal
          data we collect from you when you use our website.
        </p>

        <h2>Introduction</h2>
        <p>
          {companyName} Ltd ("we", "us", "our") respects the privacy of its users
          ("you") and is committed to protecting it through our compliance with
          this policy. This policy describes how your personal information is
          collected, used, and shared when you visit our website.
        </p>

        <h2>Information we collect</h2>
        <p>We collect various types of information from and about users of our website through:</p>
        <ul>
          <li>Direct interactions with you.</li>
          <li>Automated tracking technologies, including Google Analytics.</li>
        </ul>

        <h2>Direct interactions</h2>
        <p>
          You may provide your email address, name, and phone number when filling
          out forms on our website. For example, when you submit a contact form.
        </p>

        <h2>Automated tracking technologies</h2>
        <p>
          We use Google Analytics to track user behaviour on our website. This
          helps us optimise its performance and enhance user experience.
        </p>

        <h2>How we use your information</h2>
        <p>The information we collect is used for various purposes, including:</p>
        <ul>
          <li>To optimise website performance.</li>
          <li>To respond to your inquiries.</li>
          <li>To send you relevant information and updates.</li>
        </ul>

        <h2>Use of cookies and analytics tools</h2>
        <p>
          Our website uses Google Analytics to improve website performance and
          user experience. These tools use cookies and similar technologies to
          collect and analyse information about the use of the services.
        </p>
        <p>
          To comply with data protection laws, we will obtain your explicit
          consent before using these analytics tools.
        </p>
        <p>
          If you choose not to give consent, your experience on the website will
          not be tracked but will remain fully functional.
        </p>

        <h2>Disclosure of your information</h2>
        <p>We will not share your information with third parties unless required to do so by law.</p>

        {/*<h2>Data controller</h2>*/}
        {/*<p>The Data Controller for {companyName} Ltd is <span className="highlight">XXXX</span>.</p>*/}
        <p>
          Any queries regarding our use of personal data should be directed to <a href='office@techtonic-contractors.com'>office@techtonic-contractors.com</a>
        </p>

        <h2>Your rights</h2>
        <p>Under UK law, you have various rights about your data, including:</p>
        <ul>
          <li>The right to request access to your data.</li>
          <li>The right to request correction of any inaccurate personal data.</li>
          <li>The right to request the erasure of your data.</li>
        </ul>

        <h2>Data security</h2>
        <p>
          We employ reasonable security measures to protect your information from
          unauthorized access, alteration, or disclosure.
        </p>

        <h2>Changes to our privacy policy</h2>
        <p>
          We may update our privacy policy from time to time. Any changes will be
          posted on this page with an updated "Last Modified" date.
        </p>

        <h2>Information</h2>
        <p>For any questions regarding this privacy policy, contact:</p>
        <p>
          Email: <a href='office@techtonic-contractors.com'>office@techtonic-contractors.com</a>
        </p>
        {/*<p>*/}
        {/*  <span className="highlight">Phone: XXX</span>*/}
        {/*</p>*/}
        {/*<p>*/}
        {/*  <span className="highlight">Data Controller: XXX</span>*/}
        {/*</p>*/}
      </div>
    </section>
  );
};

export default PrivacyPolicy;
